module.exports = __webpack_public_path__ + "static/media/1024296.709b814f.jpg";